import React from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  Theme,
  WithStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Typography, Grid } from "@material-ui/core";

import AppContext from "../../AppContext";
import MemberTable, { MemberRow } from "./MemberTable";
import { useStripe } from "@stripe/react-stripe-js";

import SweetAlert from "react-bootstrap-sweetalert";
import Chip from "@material-ui/core/Chip";
import Snackbar from "@material-ui/core/Snackbar";

import DoneIcon from "@material-ui/icons/Done";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";

import alertstyles from "assets/jss/elite-feats-cms/views/sweetAlertStyle";
import TextField from "@material-ui/core/TextField";

import CustButton from "components/CustomButtons/Button";
import axios from "axios";
import { withRouter, RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";

const styles = (theme: Theme) =>
  createStyles({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  });

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  ...alertstyles,
});
function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}
interface DialogTitleProps extends WithStyles<typeof styles> {
  children?: React.ReactNode;
  onClose?: () => void;
  id?: string;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {

  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label='close'
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) =>
  createStyles({
  root: {
    padding: theme.spacing(2),
  },
  }))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) =>
  createStyles({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
  }))(MuiDialogActions);

interface GroupMembersProps extends RouteComponentProps {
  groupName?: React.ReactNode;
  isMobile?: boolean;
  members?: MemberRow[];
  open: boolean;
  setOpen: (open: boolean) => void;
}

function CustomizedDialogs(props: GroupMembersProps): React.ReactElement {
  const {t} = useTranslation()
  const classes = useStyles();
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <div>
      <Dialog
        maxWidth={props.isMobile ? "xs" : "lg"}
        fullScreen={props.isMobile}
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={props.open}
      >
        <DialogTitle id='customized-dialog-title' onClose={handleClose}>
          {props.groupName}
        </DialogTitle>
        <DialogContent dividers>
          <MemberTable rows={props.members!} />
        </DialogContent>

        <DialogActions
          style={{ paddingTop: 15, paddingBottom: 15, display: "flex" }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <CustButton
                style={{ marginRight: 5 }}
                onClick={() => {
                  props.setOpen(false);
                }}
              >
               {t('dashboard:close')}
              </CustButton>
            </Grid>
          </Grid>
        </DialogActions>

        {alert}
      </Dialog>
    </div>
  );
}

export default withRouter(CustomizedDialogs);
